"use client";
import {
  Box,
  CheckboxProps,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  InputLabelProps,
} from "@mui/material";
import React, { ReactNode, memo } from "react";
import {
  Control,
  Controller,
  ControllerProps,
  FieldPath,
  FieldValues,
} from "react-hook-form";
import AppCheckbox from "../AppCheckbox";
import clsx from "clsx";

const AppFormControlCheckbox = <T extends FieldValues>({
  control,
  label,
  name,
  controlProps,
  onChangeValueForm,
  checkboxProps,
  classNameContainer,
}: AppFormControlCheckboxProps<T>) => {
  return (
    <Box className={clsx(classNameContainer)}>
      <Controller
        name={name}
        control={control}
        render={({
          field: { onChange, ...otherFieldProps },
          fieldState: { error: errorField },
        }) => (
          <FormControl error={!!errorField} margin="normal" className="m-0">
            <>
              <AppCheckbox
                checked={otherFieldProps.value}
                onChange={(event) => {
                  const isChecked = event.target.checked;
                  if (onChangeValueForm instanceof Function)
                    onChangeValueForm(isChecked);

                  onChange(isChecked);
                }}
                className="gap-2 m-0"
                label={label}
                {...checkboxProps}
                {...otherFieldProps}
              />
              {errorField && (
                <FormHelperText>{errorField?.message}</FormHelperText>
              )}
            </>
          </FormControl>
        )}
        {...controlProps}
      />
    </Box>
  );
};

type AppFormControlCheckboxProps<T extends FieldValues> = {
  control: Control<any>;
  name: FieldPath<T>;
  checkboxProps?: CheckboxProps;
  controlProps?: Omit<ControllerProps, "render" | "name" | "control">;
  labelProps?: InputLabelProps;
  onChangeValueForm?: (isChecked?: boolean) => void;
  classNameContainer?: string;
  label?: string | ReactNode;
};

export default memo(AppFormControlCheckbox);
